// Component as UIB modal inspired by https://stackoverflow.com/a/37381735
export const maTextInputDialogComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
    template: require('./ma-text-input-dialog-component.html'),
    controller: Ctrl,
    controllerAs: 'vm'
};
function Ctrl() {
    const vm = this;
    this.$onInit = function () {
        const args = vm.resolve.args;
        vm.inputValue = args === null || args === void 0 ? void 0 : args.initialValue;
    };
}
